import { Location } from '@core/Router/locations';
import { lazy } from 'react';

const NotificationsPage = lazy(() =>
    import(/* webpackChunkName: "notifications" */ '@notifications/ui').then(m => ({ default: m.NotificationsPage })),
);

export const notificationLocations: Location[] = [
    {
        url: '/notification',
        Component: NotificationsPage,
    },
];
